import style from "../../../assets/scss/sub/startGuide.module.scss";
import {StartGuideOptions} from "./StartGuideOptions";
import React from "react";
import {useTranslation} from "react-i18next";
import {useLanguage} from "../../../hooks/hooks";
import {useStartGuideFunctions} from "./hooks/useStartGuideFunctions";
import {GuideType, MemberItemType} from "../../../types/startGuide";

export function PersonalStartGuide() {
    const { t } = useTranslation("startGuide");
    const {isKorean} = useLanguage();
    const { getImageByLanguage } = useStartGuideFunctions();
    const type = GuideType.MEMBERS;

    return(
        <div className={style.processContainerWrapper}>
            {/* 개인 회원 안내 */}
            {/* 01 회원가입 */}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.SIGNUP)}
                               idx={1} title={t('members.step1.title')} >
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>{t('members.step1.item1')}</li>
                </ul>
            </StartGuideOptions>

            {/* 02 자녀등록 */}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.MYPAGE)}
                               idx={2} title={t('members.step2.title')}
                               containerStyle="balanceBottom"
            >
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>
                        {t('members.step2.item1')}
                    </li>
                    <li className={style.listSubItem}>{t('members.step2.item2')}</li>
                    <li className={style.listSubItem}>{t('members.step2.item3')}</li>
                </ul>
            </StartGuideOptions>

            <div className={style.blueBg}>
                {/* 03 이용권 구매 */}
                <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.VOUCHER_PURCHASE)}
                                   idx={3} title={t('members.step3.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('members.step3.item1')}
                        </li>
                        <li className={style.listSubItem}>
                            {t('members.step3.item2')}
                        </li>
                    </ul>
                </StartGuideOptions>

                {/* 04 다운로드 */}
                <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.DOWNLOAD)}
                                   idx={4} title={t('members.step4.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('members.step4.item1')}
                        </li>
                        <li className={style.listItem}>
                            {t('members.step4.item2')}
                        </li>
                        <li className={style.listSubItem}>{t('members.step4.item3')}</li>
                    </ul>
                </StartGuideOptions>

                {/* 05 로그인 */}
                <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.LOGIN)}
                                   idx={5} title={t('members.step5.title')}>
                    <ul className={style.stepDescription}>
                        <li className={style.listItem}>
                            {t('members.step5.item1')}
                        </li>
                        <li className={style.listItem}> {t('members.step5.item2')}</li>
                    </ul>
                </StartGuideOptions>
            </div>

            {/*검사진행*/}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.GAME)}
                               idx={6} title={t('members.step6.title')}
                               containerStyle="balanceTop">
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>{t('members.step6.item1')}</li>
                </ul>
            </StartGuideOptions>

            {/*결과보기*/}
            <StartGuideOptions img={getImageByLanguage(type, isKorean, MemberItemType.RESULT)}
                               idx={7} title={t('members.step7.title')}>
                <ul className={style.stepDescription}>
                    <li className={style.listItem}>{t('members.step7.item1')}</li>
                    <li className={style.listSubItem}>{t('members.step7.item2')}</li>
                </ul>
            </StartGuideOptions>
        </div>

    )
}